import { DefaultEffects, IButtonStyles, IContextualMenuStyleProps, IContextualMenuStyles, IDetailsColumnStyleProps, IDetailsColumnStyles, IDetailsListStyleProps, IDetailsListStyles, IDetailsRowStyleProps, IDetailsRowStyles, IImageStyleProps, IImageStyles, IShimmeredDetailsListProps, IShimmeredDetailsListStyles, IStyleFunctionOrObject, mergeStyles } from "@fluentui/react";

//#region CONTAINER

export const contractDetailContainer = mergeStyles([{
    width: '100%',
    height: 'auto',
    marginTop: '1dvh',
    marginBottom: '1dvh',
    border: '2px solid #a9c963',
    borderRadius: DefaultEffects.roundedCorner6,
    boxShadow: DefaultEffects.elevation16,
    fontFamily: 'Nunito'
}]);

//#region HEADER

export const contractDetailHeaderContainer = mergeStyles([{
    padding: '1dvh',
    borderRadius: DefaultEffects.roundedCorner6,
    backgroundColor: '#F0F0F0',
    width: '100%',
    height: '4rem',
}]);

export const xxlContractDetailHeaderContainer = mergeStyles([{
    padding: '1dvh',
    borderRadius: DefaultEffects.roundedCorner6,
    backgroundColor: '#F0F0F0',
    width: '100%',
    height: '3.2rem',
}]);

export const xlContractDetailHeaderContainer = mergeStyles([{
    padding: '1dvh',
    borderRadius: DefaultEffects.roundedCorner6,
    backgroundColor: '#F0F0F0',
    width: '100%',
    height: '4rem',
}]);

export const lgContractDetailHeaderContainer = mergeStyles([{
    padding: '1dvh',
    borderRadius: DefaultEffects.roundedCorner6,
    backgroundColor: '#F0F0F0',
    width: '100%',
    height: '3.5rem',
}]);

export const mdContractDetailHeaderContainer = mergeStyles([{
    padding: '1dvh',
    borderRadius: DefaultEffects.roundedCorner6,
    backgroundColor: '#F0F0F0',
    width: '100%',
    height: '2.8rem',
}]);

export const smContractDetailHeaderContainer = mergeStyles([{
    padding: '1dvh',
    borderRadius: DefaultEffects.roundedCorner6,
    backgroundColor: '#F0F0F0',
    width: '100%',
    height: '3rem',
}]);

//#endregion HEADER

//#endregion CONTAINER

//#region CONTENT

//#region TITLE

export const titleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.5rem',
    fontWeight: 500,
    color: '#2A7DE1',
}]);

export const xxlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.3rem',
    fontWeight: 500,
    color: '#2A7DE1',
}]);

export const xlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.1rem',
    fontWeight: 500,
    color: '#2A7DE1',
}]);

export const lgTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 500,
    color: '#2A7DE1',
}]);

export const mdTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '0.9rem',
    fontWeight: 600,
    color: '#2A7DE1',
}]);

export const smTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '0.8rem',
    fontWeight: 600,
    color: '#2A7DE1',
}]);

//#endregion TITLE

//#region ICON

export const iconStyles: IButtonStyles  = {
    icon: {
        color: '#2A7DE1',
        fontSize: '1.5rem',
    }
};

export const xxlIconStyles: IButtonStyles  = {
    icon: {
        color: '#2A7DE1',
        fontSize: '1.3rem',
    }
};

export const xlIconStyles: IButtonStyles  = {
    icon: {
        color: '#2A7DE1',
        fontSize: '1.1rem',
    }
};

export const lgIconStyles: IButtonStyles  = {
    icon: {
        color: '#2A7DE1',
        fontSize: '1rem',
    }
};

export const mdIconStyles: IButtonStyles  = {
    icon: {
        color: '#2A7DE1',
        fontSize: '0.9rem',
    }
};

export const smIconStyles: IButtonStyles  = {
    icon: {
        color: '#2A7DE1',
        fontSize: '0.8rem',
    }
};

//#endregion ICON

//#region LIST

export const listStyles: IStyleFunctionOrObject<IDetailsRowStyleProps, IDetailsRowStyles> = {
    cell: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        fontWeight: 400,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
};

export const xxlListStyles: IStyleFunctionOrObject<IDetailsRowStyleProps, IDetailsRowStyles> = {
    cell: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 400,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
};

export const xlListStyles: IStyleFunctionOrObject<IDetailsRowStyleProps, IDetailsRowStyles> = {
    cell: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 400,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
};

export const lgListStyles: IStyleFunctionOrObject<IDetailsRowStyleProps, IDetailsRowStyles> = {
    cell: {
        fontFamily: 'Nunito',
        fontSize: '0.98rem',
        fontWeight: 400,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
};

export const mdListStyles: IStyleFunctionOrObject<IDetailsRowStyleProps, IDetailsRowStyles> = {
    cell: {
        fontFamily: 'Nunito',
        fontSize: '0.9rem',
        fontWeight: 400,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
};

export const smListStyles: IStyleFunctionOrObject<IDetailsRowStyleProps, IDetailsRowStyles> = {
    cell: {
        fontFamily: 'Nunito',
        fontSize: '0.875rem',
        fontWeight: 400,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
};

export const columnListStyles: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles> = {
    cellName: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        fontWeight: 600,
    }
};

export const xxlColumnListStyles: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles> = {
    cellName: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
    }
};

export const xlColumnListStyles: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles> = {
    cellName: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
    }
};

export const lgColumnListStyles: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles> = {
    cellName: {
        fontFamily: 'Nunito',
        fontSize: '0.9rem',
        fontWeight: 600,
    }
};

export const mdColumnListStyles: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles> = {
    cellName: {
        fontFamily: 'Nunito',
        fontSize: '0.9rem',
        fontWeight: 600,
    }
};

export const smColumnListStyles: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles> = {
    cellName: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
    }
};

export const signButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#ff9900',
        borderColor: '#ff9900',
        color: 'white',
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        borderRadius: DefaultEffects.roundedCorner6,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#cc7700',
        borderColor: '#cc7700'
    },
    rootPressed: {
        backgroundColor: '#995500',
        borderColor: '#995500'
    }
};

export const xxlSignButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#ff9900',
        borderColor: '#ff9900',
        color: 'white',
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        borderRadius: DefaultEffects.roundedCorner6,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#cc7700',
        borderColor: '#cc7700'
    },
    rootPressed: {
        backgroundColor: '#995500',
        borderColor: '#995500'
    }
};

export const xlSignButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#ff9900',
        borderColor: '#ff9900',
        color: 'white',
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        borderRadius: DefaultEffects.roundedCorner6,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#cc7700',
        borderColor: '#cc7700'
    },
    rootPressed: {
        backgroundColor: '#995500',
        borderColor: '#995500'
    }
};

export const lgSignButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#ff9900',
        borderColor: '#ff9900',
        color: 'white',
        fontFamily: 'Nunito',
        fontSize: '0.99rem',
        fontWeight: 600,
        borderRadius: DefaultEffects.roundedCorner6,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#cc7700',
        borderColor: '#cc7700'
    },
    rootPressed: {
        backgroundColor: '#995500',
        borderColor: '#995500'
    }
};

export const mdSignButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#ff9900',
        borderColor: '#ff9900',
        color: 'white',
        fontFamily: 'Nunito',
        fontSize: '0.9rem',
        fontWeight: 600,
        borderRadius: DefaultEffects.roundedCorner6,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#cc7700',
        borderColor: '#cc7700'
    },
    rootPressed: {
        backgroundColor: '#995500',
        borderColor: '#995500'
    }
};

export const smSignButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#ff9900',
        borderColor: '#ff9900',
        color: 'white',
        fontFamily: 'Nunito',
        fontSize: '0.875rem',
        fontWeight: 600,
        borderRadius: DefaultEffects.roundedCorner6,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#cc7700',
        borderColor: '#cc7700'
    },
    rootPressed: {
        backgroundColor: '#995500',
        borderColor: '#995500'
    }
};

//#endregion

//#region IMAGE

export const imageStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(30rem, 12dvh, 40dvh)',
    margin: '0 auto',
}]);

export const xxlImageStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(30rem, 12dvh, 40dvh)',
    margin: '0 auto',
}]);

export const xlImageStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(25rem, 12dvh, 35dvh)',
    margin: '0 auto',
}]);

export const lgImageStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(20rem, 12dvh, 30dvh)',
    margin: '0 auto',
}]);

export const mdImageStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(15rem, 12dvh, 25dvh)',
    margin: '0 auto',
}]);

export const smImageStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(10rem, 12dvh, 20dvh)',
    margin: '0 auto',
}]);

//#endregion IMAGE

export const actionContainerStyles = mergeStyles([{
    padding: '1dvh',
}]);

//#endregion CONTENT

//#region COMMANDBAR

export const commandBarButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#323130'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#323130'
    },
    icon: {
        fontSize: '1rem'
    }
}

export const xxlCommandBarButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#323130'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#323130'
    },
    icon: {
        fontSize: '1rem'
    }
}

export const xlCommandBarButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#323130'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#323130'
    },
    icon: {
        fontSize: '1rem'
    }
}

export const lgCommandBarButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '0.98rem',
        fontWeight: 600,
        color: '#323130'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '0.98rem',
        fontWeight: 600,
        color: '#323130'
    },
    icon: {
        fontSize: '1rem'
    }
}

export const mdCommandBarButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '0.9rem',
        fontWeight: 600,
        color: '#323130'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '0.9rem',
        fontWeight: 600,
        color: '#323130'
    },
    icon: {
        fontSize: '1rem'
    }
}

export const smCommandBarButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '0.8rem',
        fontWeight: 600,
        color: '#323130'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '0.8rem',
        fontWeight: 600,
        color: '#323130'
    },
    icon: {
        fontSize: '1rem'
    }
}

//#endregion COMMANDBAR